class Confetti {
    constructor(container, options = {}) {
      if (!container) return;

      this.container = container;
      this.containerEl = null;
      this.confettiInterval = null;
      this.timeRun = 0;

      this.confettiColors = options.colors || [
        "#EF2964",
        "#00C09D",
        "#2D87B0",
        "#48485E",
        "#EFFF1D",
      ];

      this.confettiAnimations = ["slow", "medium", "fast"];

      this.setupElement();
      this.render();
    }

    setupElement() {
      const containerEl = document.createElement("div");
      const position = window.getComputedStyle(this.container).position;

      if (position !== "relative" && position !== "absolute" && position !== "fixed") {
        this.container.style.position = "relative";
      }

      containerEl.className = "f-confetti-container";
      this.container.appendChild(containerEl);
      this.containerEl = containerEl;
    }

    stopConfetti() {
      clearInterval(this.confettiInterval);

      window.setTimeout(() => {
        if (this.containerEl && this.containerEl.parentNode) {
          this.containerEl.parentNode.removeChild(this.containerEl);
        }
      }, 1500);
    }

    render() {
      this.confettiInterval = window.setInterval(() => {
        this.timeRun += 1;

        if (this.timeRun >= 160) {
          this.stopConfetti();
          return;
        }

        const confettiEl = document.createElement("div");
        const confettiSize = Math.floor(Math.random() * 3) + 7 + "px";
        const confettiBackground =
          this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
        const confettiLeft = Math.floor(Math.random() * this.container.offsetWidth) + "px";
        const confettiAnimation =
          this.confettiAnimations[
            Math.floor(Math.random() * this.confettiAnimations.length)
          ];

        confettiEl.className = "f-confetti f-confetti--animation-" + confettiAnimation;
        confettiEl.style.left = confettiLeft;
        confettiEl.style.width = confettiSize;
        confettiEl.style.height = confettiSize;
        confettiEl.style.backgroundColor = confettiBackground;

        window.setTimeout(() => {
          if (confettiEl.parentNode) {
            confettiEl.parentNode.removeChild(confettiEl);
          }
        }, 3000);

        this.containerEl.appendChild(confettiEl);
      }, 20);
    }
}

window.ShopifyConfetti = Confetti;

